import { atom } from 'jotai';
import { RootUser } from './userType';

export const userAtom = atom<RootUser | null>(null);
